import { createMuiTheme } from '@material-ui/core/styles'
import { heading } from '../../utils/utils'

const mainFont = 'Adolfo Dominguez'

const white = '#fff'
const black = '#000'
const primaryMain = '#000' //'#00233A'
const primaryLight = '#E5E9EB'
const secondaryMain = '#fff' //'#B4D2C1'
const greyLight = '#F7F7F9'
const grey = '#BEBEBE' //

// const imp = '!important'

// const f11 = `11px`
const f12 = `12px`
const f13 = `13px`
const f14 = `14px`
const f15 = `15px`
const f16 = `16px`
const f18 = `18px`

// const f20 = `20px`
// const f22 = `22px`
const f24 = `24px`
const f30 = `30px`
const f32 = `32px`

const body = {
  fontSize: f14,
  lineHeight: 1.6,
}
const body2 = {
  fontSize: f13,
  lineHeight: 1.67,
}

const breakpoints = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1440,
}

const theme = createMuiTheme({
  themeFont: {
    //WARNING FONT NAME WITH SPACE SHOULD HAVE A +. NEXT JS TRIGGER BAD URL FOR GOOGLE FONT
    main: mainFont.replace(' ', '+'),
  },
  breakpoints: {
    values: breakpoints,
  },
  typography: {
    fontFamily: `${mainFont}, sans-serif`,
    h1: {
      lineHeight: 1.15,
      ...heading(f32, f32, 700, 700, mainFont, mainFont, false),
    },
    h2: {
      lineHeight: 1.15,
      ...heading(f14, f30, 700, 700, mainFont, mainFont, false),
    },
    h3: {
      lineHeight: 1.4,
      ...heading(f18, f18, 700, 700, mainFont, mainFont, false),
    },
    h4: {
      lineHeight: 1.55,
      ...heading(f16, f16, 700, 700, mainFont, mainFont, false),
    },
    h5: {
      lineHeight: 1.25,
      ...heading(f14, f14, 600, 700, mainFont, mainFont, false),
    },
    h6: {
      lineHeight: 1.25,
      ...heading(f12, f12, 600, 700, mainFont, mainFont, false),
    },
    body1: {
      ...body,
      color: `${black} !important`,
    },
    body2: {
      ...body2,
      color: `${black} !important`,
    },
    caption: {
      fontSize: f12,
      lineHeight: 1.17,
      fontWeight: 400,
    },
    button: {
      fontSize: f15,
      lineHeight: 1.67,
      textTransform: 'inherit',
    },
  },
  palette: {
    common: {
      black: black,
      white: white,
    },
    background: {
      default: white,
      paper: white,
    },
    primary: {
      main: primaryMain,
    },
    secondary: {
      main: secondaryMain,
    },
    success: {
      main: '#47E169',
    },
    error: {
      main: '#FA3232',
    },
    warning: {
      main: '#FF8333',
    },
    divider: greyLight,
    primaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    secondaryTransparent: {
      main: primaryMain,
      light: primaryLight,
    },
    ternary: {
      main: '#0082C3',
      light: '#F1FAFF',
    },
    accent: {
      main: '#FFEA28',
    },
  },
  sizes: {
    headerHeight: 60,
    headerHeightTransparent: 90,
    logoWidth: 110,
    logoHeight: 30,
    footerBG: 168,
    basketWidth: 340,
    basketWidthLG: 440,
  },
  extraColors: {
    grey: '#D5D2D9',
    greyLight: '#F5F3F8',
    greyMedium: '#C0BCC6',
    greyText: '#6F677B',
  },
  shadows: [
    'none',
    '0px 0px 15px rgba(46, 46, 46, 0.1)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  spacing: 8,
  shape: {
    borderRadius: 4,
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '.menu': {
          '&__item': {
            '&:not(:last-child):after': {
              content: '"" !important',
            },
            '&:not(:first-child)': {
              '& .menu__link:before': {
                content: '"ADN " !important',
                fontWeight: '400 !important',
              },
            },
          },

          '&__link,&-mobile__item': {
            fontWeight: '700 !important',
            whiteSpace: 'nowrap !important',
          },

          '&-mobile__item>a': {
            '&::before': {
              content: '"ADN " !important',
              fontWeight: '400 !important',
              //color: `${grey}!important`,
            },
          },
        },

        '.mobile-carousel': {
          'z-index': 'auto !important',
        },

        'section-faq__cta': {
          [`@media (max-width: ${breakpoints.lg}px)`]: {
            fontSize: '12px !important',
            backgroundColor: `${primaryMain} !important`,
          },
        },

        '.discover': {
          '&__card': {
            display: 'flex !important',
            flexDirection: 'column-reverse !important',
          },
          '&-product': {
            '&__content': {
              position: 'static !important',
              textAlign: 'center !important',
              paddingTop: '12px !important',
              [`@media (min-width: ${breakpoints.lg}px)`]: {
                paddingTop: '30px !important',
              },
            },
            '&__title': {
              fontWeight: '600 !important',
              fontSize: '12px !important',
              [`@media (min-width: ${breakpoints.lg}px)`]: {
                fontSize: '16px !important',
              },
            },
          },
        },
        '.productCard': {
          '&__price': {
            '&--original': {
              color: `${grey} !important`,
            },
          },
        },

        '.basket': {
          '&-product__total': {
            color: `${black} !important`,
          },
        },

        '.cart-badge': {
          color: `${white} !important`,
          backgroundColor: `${black} !important`,
        },

        '.funnel': {
          '&__nav': {
            '&--active': {
              color: `${black} !important`,
              backgroundColor: `${white} !important`,
              borderColor: `${black} !important`,
            },
          },
        },

        '.footer': {
          '&__bottomRow2': {
            flexDirection: 'row-reverse !important',
            '&Col': {
              justifyContent: 'flex-end !important',
            },
          },
          '&__menu': {
            [`@media (min-width: ${breakpoints.lg}px)`]: {
              textAlign: 'start !important',
            },
            '& > a:last-child': {
              [`@media (max-width: ${breakpoints.lg}px)`]: {
                display: 'block !important',
                marginLeft: '0 !important',
              },
            },
          },
          '&__bottomRow1Col': {
            [`@media (min-width: ${breakpoints.md}px)`]: {
              textAlign: 'start !important',
            },
          },
          '&__logo': {
            [`@media (min-width: ${breakpoints.md}px)`]: {
              display: 'inline-block',
              marginLeft: '1rem',
            },
            minHeight: '6.25rem',
          },
        },

        '.daterange__btn': {
          color: `${grey}!important`,
        },

        '.daterange__submit': {
          fontWeight: '600 !important',
          padding: '8px 24px !important',
          fontSize: '12px !important',

          [`@media (min-width: ${breakpoints.lg}px)`]: {
            fontWeight: '700 !important',
            padding: '12px 42px !important',
            fontSize: '16px !important',
          },
        },

        '.recapOrder__title': {
          '& h3': {
            color: `${black} !important`,
          },
        },

        '.recapOrder__account_cta': {
          color: `${black} !important`,
          borderColor: ` ${black} !important`,
        },

        '.date_form': {
          [`@media (max-width: ${breakpoints.lg}px)`]: {
            background: 'none !important',
          },
        },

        '.react-datepicker__navigation': {
          backgroundColor: `${black}!important`,
        },
        '.react-datepicker__day--in-range,.react-datepicker__day--selected': {
          color: `${white}!important`,
          backgroundColor: `${black}!important`,
        },
        '.react-datepicker-popper>div>div>div+div,.react-datepicker__day--today':
          {
            backgroundColor: `${black}!important`,
            '&>div': {
              color: `${white}!important`,
            },
          },

        '.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover, .react-datepicker__month-text--selected:hover, .react-datepicker__month-text--in-selecting-range:hover, .react-datepicker__month-text--in-range:hover, .react-datepicker__quarter-text--selected:hover, .react-datepicker__quarter-text--in-selecting-range:hover, .react-datepicker__quarter-text--in-range:hover, .react-datepicker__year-text--selected:hover, .react-datepicker__year-text--in-selecting-range:hover, .react-datepicker__year-text--in-range:hover ':
          {
            color: `${white}!important`,
          },

        '.react-datepicker-popper>div>div>div+div, .react-datepicker__day--today':
          {
            color: `${white}!important`,
          },
        // Popper z-index and small gap; let Popper compute exact placement
        '.react-datepicker-popper': {
          zIndex: 1500,
        },
        '.react-datepicker-popper[data-placement^="top"]': {
          // marginTop: '8px !important',
          // marginBottom: '0 !important',
          transform: 'translate3d(40px, 49px, 0px) !important',
        },
        '.react-datepicker-popper[data-placement^="bottom"]': {
          // marginTop: '0 !important',
          // marginBottom: '8px !important',
        },
        '.header': {
          '&--home': {
            top: '0 !important',
            '&--top': {
              top: '1.9375rem !important',
            },
          },
          '&__logo': {
            '@media (min-width: 768px)': {
              height: '30px !important',
            },
          },
          '&__left': {
            [`@media (max-width: ${breakpoints.lg}px)`]: {
              flex: 'auto !important',
              width: '100% !important',
            },

            '&>a': {
              [`@media (max-width: ${breakpoints.lg}px)`]: {
                margin: 'auto !important',
              },
            },
          },

          '&__right': {
            [`@media (max-width: ${breakpoints.lg}px)`]: {
              width: 'auto !important',
            },
          },

          '&__cta': {
            '&--instore--choice': {
              color: `${black} !important`,
            },
          },
        },
        '.hero': {
          '&__home': {
            [`@media (max-width: ${breakpoints.sm}px)`]: {
              height: '75vh !important',
              minHeight: 'auto !important',
            },
            '&-logo-title': {
              [`@media (max-width: ${breakpoints.sm}px)`]: {
                width: '77%',
              },
            },
          },
        },
        '.banner': {
          padding: '12px 16px !important',
          background: '#000 !important',
          height: '1.9375rem !important',
          fontWeight: '400 !important',
        },
        '.shop-menu': {
          '&--products': {
            display: 'flex !important',
          },
          '&__right-controls__container': {
            [`@media (max-width: ${breakpoints.sm}px)`]: {
              flexDirection: 'column !important',
              '& .shop-menu__cta': {
                paddingTop: '0 !important',
              },
            },
          },
          '&__sort-input': {
            '&.MuiOutlinedInput-root': {
              borderRadius: '4px !important',
            },
          },
        },
        '.shop-filters': {
          marginBottom: 'auto !important',
        },
        '.section-discover': {
          '&>div': {
            flexDirection: 'column-reverse !important',
          },
          '&__subtitle': {
            textAlign: 'center !important',
          },
          '&__footer': {
            paddingTop: '3.125rem !important',

            '& .discover__cta>span': {
              fontWeight: '600 !important',
              padding: '0.5rem 1.5rem !important',
              width: 170,
              // padding: '0.75rem 2.25rem !important',
              fontSize: '0.75rem !important',

              [`@media (min-width: ${breakpoints.lg}px)`]: {
                fontWeight: '700 !important',
                fontSize: '1rem !important',
              },
            },
          },
        },
        '.section-faq': {
          [`@media (max-width: ${breakpoints.lg}px)`]: {
            paddingTop: '79px !important',
            '& .section-faq__cta': {
              width: '170px !important',
              '& p': {
                fontSize: '12px !important',
                backgroundColor: `${primaryMain} !important`,
              },
            },
          },
          '&__list-container': {
            marginBottom: '2.625rem !important',
          },
          '&__title': {
            paddingTop: '0 !important',
            marginBottom: '0.625rem !important',
          },
          '& .faq': {
            boxShadow: 'none !important',
            '&__item': {
              marginBottom: '0!important',
              '&:last-child': {
                '& .faq__question': {
                  borderBottom: '0 !important',
                },
              },
            },
            '&__question': {
              fontWeight: '600 !important',
              [`@media (min-width: ${breakpoints.lg}px)`]: {
                fontSize: '1.125rem !important',
              },
              borderBottom: `1px solid ${black} !important`,
              marginBottom: '0!important',
              padding: '0.6875rem 0!important',
              [`@media (max-width: ${breakpoints.lg}px)`]: {
                padding: '0.5rem 0!important',
                '& p': {
                  fontSize: '12px!important',
                },
              },
              '&:hover, &:focus': {
                background: 'none !important',
              },
              '&[aria-expanded=true]': {
                color: `${black} !important`,
                background: 'none!important',
                borderColor: 'transparent !important',
                '&>.MuiButton-label:after': {
                  transform: 'rotate(-180deg)',
                },
              },
              '&>.MuiButton-label': {
                '&:after': {
                  content: '""',
                  width: 35,
                  height: 35,
                  background:
                    'url("./images/maje/icon_arrow_down.svg") no-repeat 50% 50%',
                  display: 'none !important',
                },
                [`@media (max-width: ${breakpoints.lg}px)`]: {
                  fontSize: '10px !important',
                  '&:after': {
                    content: '""',
                    width: 10,
                    height: 7,
                    backgroundSize: 'contain !important',
                  },
                },
              },
            },
            '&__btn': {
              border: '0!important',
              color: `${primaryMain} !important`,
            },
            '&__answer': {
              fontSize: '1rem !important',
              fontWeight: '300 !important',
              borderColor: 'transparent !important',
              borderBottom: `1px solid ${black} !important`,
              padding: '0 1rem 0.75rem !important',
              [`@media (max-width: ${breakpoints.lg}px)`]: {
                fontSize: '12px!important',
                '& p': {
                  fontSize: '12px!important',
                },
                padding: '0 0.6875rem 0.75rem !important',
              },
            },
          },
          '&__cta': {
            height: '2.875rem',
            fontSize: '1rem',
            fontWeight: '400',
            padding: '0.75rem 0.375rem !important',
          },
        },

        '.section-hiw': {
          paddingBottom: '0px !important',

          '&__spacing': {
            paddingBottom: '0px !important',
          },
        },

        '.hiw': {
          [`@media (max-width: ${breakpoints.lg}px)`]: {
            alignItems: 'center !important',
            flexDirection: 'column !important',
            textAlign: 'center !important',
          },
          '&__icon': {
            '&>img': {
              height: '41px !important',
              width: 'auto !important',
              [`@media (min-width: ${breakpoints.lg}px)`]: {
                height: '82px !important',
              },
            },
          },

          '&__title': {
            fontWeight: '600 !important',
            fontSize: '0.75rem !important',
            [`@media (max-width: ${breakpoints.lg}px)`]: {
              height: '1.375rem !important',
              fontSize: '1rem !important',
            },
          },

          '&__header': {
            minHeight: '50px !important',
          },

          '&__desc': {
            fontWeight: '300 !important',
            fontSize: '10px !important',
            [`@media (min-width: ${breakpoints.lg}px)`]: {
              fontSize: '16px !important',
            },
            [`@media (max-width: ${breakpoints.lg}px)`]: {
              fontSize: '12px !important',
            },
          },
        },

        '.section-menu': {
          padding: '0px !important',
        },
        '.pack': {
          '&__prev': {
            color: `${white} !important`,
            backgroundColor: `${black} !important`,
          },
          '&__cta, &__link': {
            padding: '12px 18px !important',
            width: '11.5rem !important',
          },
          '&__cta, &__a-link, &__link': {
            [`@media (max-width: ${breakpoints.sm}px)`]: {
              width: '100% !important',
            },
          },
        },
        '.payment-form': {
          '&__submit-progress': {
            color: `${black} !important`,
            border: `1px solid ${black} !important`,
            '& .MuiButton-label > span': {
              mixBlendMode: 'difference',
              color: `${white} !important`,
            },
          },
        },
        '.commitment': {
          backgroundColor: `${black} !important`,
          color: `${white} !important`,
          '&__desc > p': {
            color: `${white} !important`,
          },
        },
        '.footer__bottom': {
          '& .MuiContainer-root': {
            display: 'flex !important',
            flexDirection: 'column-reverse !important',
            gap: '1rem',
          },
        },
        '.daterange_popper > div': {
          color: `${black} !important`,
        },
      },
    },
    MuiButton: {
      root: {
        padding: '12px 45px',
        borderRadius: 4,
      },
      sizeSmall: {
        padding: '4px 16px',
        lineHeight: 1.6,
      },
      label: {
        lineHeight: '21px !important',
      },
      sizeLarge: {
        padding: '12px 45px',
      },
      contained: {
        boxShadow: 'none',
        '&:hover, &:focus, &:active, &.selected': {
          boxShadow: 'none',
        },
        color: `${white} !important`,
        backgroundColor: `${black} !important`,
      },
      outlined: {
        padding: '12px 45px',
      },
      outlinedSizeLarge: {
        padding: '12px 45px',
      },
      outlinedSizeSmall: {
        padding: '4px 16px',
        lineHeight: 1.6,
      },
      outlinedSecondary: {
        backgroundColor: black,
      },
    },
    MuiPaper: {
      root: {
        boxShadow: '0px 0px 15px rgba(46, 46, 46, 0.1)',
      },
      rounded: {
        borderRadius: 4,
      },
    },
    MuiSelect: {
      root: {
        color: primaryMain,
      },
      selectMenu: {
        '&:focus': {
          background: white,
        },
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        '&.Mui-checked': {
          color: `${black} !important`,
        },
      },
    },
    MuiChip: {
      root: {
        borderRadius: 0,
        fontSize: 15,
        fontWeight: 700,
        color: black,
        backgroundColor: 'transparent',
        height: 25,
        padding: 0,
      },
      label: {
        padding: 0,
      },
      sizeSmall: {
        height: 22,
        fontSize: 12,
        fontWeight: 400,
      },
      labelSmall: {
        paddingLeft: 10,
        paddingRight: 10,
      },
      colorPrimary: {
        color: primaryMain,
        backgroundColor: 'transparent',
      },
      colorSecondary: {
        color: secondaryMain,
        backgroundColor: 'transparent',
      },
    },
  },
  settings: {
    productsSwiperSlidesPerView: 1,
    priceFormat: 'comma_two_decimals',
    priceLocaleFormat: 'es-ES',
  },
})

export default theme
